import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce159f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "personal-info-page" }
const _hoisted_2 = { class: "child-booking-link" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-child" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-2" }, "個人情報を入力してください（検証用）", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, [
  /*#__PURE__*/_createTextVNode(" ※個人情報は上書き更新されます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 必ずLINEアカウント保有者様の情報を入力してください。 ")
], -1))
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("姓 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_9 = {
  id: "first-name-error",
  class: "p-error"
}
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_12 = {
  id: "last-name-error",
  class: "p-error"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("メールアドレス "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("電話番号 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（郵便番号） "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（都道府県・市区町村・丁目）"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（番地・建物）"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("生年月日 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_22 = { class: "grid flex-wrap birthday-wrap" }
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = { class: "flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年", -1))
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = { class: "flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月", -1))
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("性別 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_33 = { class: "flex flex-wrap gap-3" }
const _hoisted_34 = { class: "flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "male",
  class: "ml-2"
}, "男性", -1))
const _hoisted_36 = { class: "flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "female",
  class: "ml-2"
}, "女性", -1))
const _hoisted_38 = { class: "flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "unknown",
  class: "ml-2"
}, "その他", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "text-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須", -1))
const _hoisted_43 = { class: "flex flex-wrap gap-3" }
const _hoisted_44 = ["for"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "お店に伝えたいこと", -1))
const _hoisted_46 = { class: "mb-8" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "その他・伝達事項", -1))
const _hoisted_48 = { class: "controller-wrapper" }

import { onBeforeMount, ref, computed, Ref } from "vue"; // Composition API
import { useStore } from "vuex"; // Vuexストアアクセス

// PrimeVueコンポーネント
import RadioButton from "primevue/radiobutton";
import Textarea from "primevue/textarea";
import Checkbox from "primevue/checkbox";

// アプリ内共通ユーティリティ・定数
import RouterUtils from "@/common/utils/router.util"; // 画面遷移ユーティリティ
import RouterConstants from "../constants/router.constants"; // 遷移先定数
import ValidateBookingSteps from "../validates/validate.booking.steps"; // ステップバリデーションロジック
import type { ICustomer, IWorryContent } from "../typings"; // 顧客型定義
import ApiRouterConstants from "@/common/constants/api.router.constants"; // APIルート
import ApiRouterCustomerConstants from "../constants/api.router.constants"; // APIルート

// ユーティリティ・定数
import axios from "axios/index"; // HTTPリクエスト
import { get, set } from "@vueuse/core"; // VueUseの状態ユーティリティ
import moment from "moment"; // 日付整形ライブラリ

// Vuexストアの取得

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfo',
  setup(__props) {

/**
 * 顧客情報入力画面のロジック（個人情報フォーム）
 *
 * - LINE連携を通じて取得した顧客情報をフォームに自動反映
 * - 生年月日や電話番号などの整形・バリデーションを行う
 * - フォーム送信時はVuexに情報を保存し、確認画面へ遷移する
 *
 * 使用技術：
 * - Composition API + <script setup>
 * - PrimeVue コンポーネント（InputText, RadioButton, Dropdownなど）
 * - moment.js を使った日付操作
 * - Vuex を使った状態保存
 */

// Vue Core機能
const store = useStore();

/**
 * 顧客の個人情報を格納する reactive オブジェクト
 *
 * - firstName: 名
 * - lastName: 姓
 */
let selectedInfo = ref<ICustomer>({
  firstName: "",
  lastName: "",
  tel: "",
  email: "",
  address: "",
  addressNumber: "",
  birthday: "",
  gender: "male",
  zipcode: "",
  note: "",
  noteSymptom: "",
  selectedWorryTags: [],
  others: "",
});

/**
 * 生年月日ドロップダウン選択用の reactive オブジェクト
 */
const birthday = ref({
  date: "",
  month: "",
  year: "",
});

/** 生年月日の「年」選択肢リスト */
const yearsList = ref<string[]>([]);

/** 生年月日の「月」選択肢リスト（1〜12固定） */
const monthsList = ref<string[]>(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);

/** 悩みコンテンツリスト */
const worryContents = ref<IWorryContent[]>([]);

/** 選択された悩みタグのIDリスト */
const selectedWorryTags = ref<number[]>([]);

/**
 * 生年月日の「日」選択肢リストを月・年から動的に計算
 *
 * @returns {string[]} 日付一覧（例: ["1", "2", ..., "31"]）
 */
const getDaysList = computed(() => {
  const days = new Date(Number(birthday.value.year), Number(birthday.value.month), 0).getDate();
  let dayList = [];
  for (let i = 1; i <= days; i++) {
    dayList.push(i);
  }

  return dayList.map(String);
});

/** 名（firstName）のバリデーションエラーメッセージ */
const firstNameErrorMessage = ref<string>("");

/** 姓（lastName）のバリデーションエラーメッセージ */
const lastNameErrorMessage = ref<string>("");

/**
 * 郵便番号のバリデーション：正しい形式（7桁または3桁-4桁）かどうかを判定
 *
 * @returns {boolean} true の場合は「有効な郵便番号」
 */
const isValidZipcode = computed(() => {
  const zipcode = selectedInfo.value.zipcode || "";
  return /^(?:\d{7}|\d{3}-\d{4})$/.test(zipcode);
});

/**
 * 生年月日の「年」選択肢を 1900〜現在年 まで生成する
 */
const getYearsList = () => {
  const startYear = 1900;
  const endYear = new Date().getFullYear();
  for (let i = endYear; i >= startYear; i--) {
    yearsList.value = [...yearsList.value, i.toString()];
  }
};

/**
 * 悩みコンテンツを取得する
 */
const fetchWorryContents = async () => {
  try {
    const response = await axios.get(ApiRouterCustomerConstants.API_WORRY_CONTENTS, {
      params: {
        clinic_id: store.getters["line_account/clinicId"],
      },
      headers: { Accept: "application/json" },
    });
    worryContents.value = response.data;
  } catch (error) {
    console.log("Failed to fetch worry contents:", error);
  }
};

/**
 * 悩み項目の必須チェック：各contentごとに少なくとも1つのタグが選択されているかを判定
 *
 * @returns {boolean} true の場合は「必須項目が未選択」
 */
const hasUnselectedWorryContent = computed(() => {
  if (worryContents.value.length === 0) {
    return false; // 悩みコンテンツがない場合はチェック不要
  }

  // 各contentごとに、そのcontentに属するタグが1つ以上選択されているかをチェック
  return worryContents.value.some(content => {
    const contentTagIds = content.worry_tags.map(tag => tag.id);
    const hasSelectedTag = contentTagIds.some(tagId => selectedWorryTags.value.includes(tagId));
    return !hasSelectedTag; // 選択されていないcontentがある場合はtrue
  });
});

/**
 * 入力チェック：すべての必須項目が正しく入力されているかを判定
 *
 * @returns {boolean} true の場合は「送信ボタンを無効化」
 */
const disableSubmitButton = computed(() => {
  return (
    selectedInfo.value.email == "" ||
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(selectedInfo.value.email) ||
    selectedInfo.value.firstName == "" ||
    selectedInfo.value.lastName == "" ||
    selectedInfo.value.tel == "" ||
    !/^(0\d-\d{4}-\d{4}|0\d{2}-\d{3}-\d{4}|0\d{3}-\d{2}-\d{4}|0\d{2}-\d{4}-\d{4}|0\d{9,10})$/.test(
      selectedInfo.value.tel
    ) ||
    selectedInfo.value.address == "" ||
    selectedInfo.value.addressNumber == "" ||
    selectedInfo.value.zipcode == "" ||
    !/^(?:\d{7}|\d{3}-\d{4})$/.test(selectedInfo.value.zipcode || "") ||
    birthday.value.date == "" ||
    birthday.value.month == "" ||
    birthday.value.year == "" ||
    selectedInfo.value.gender == "" ||
    hasUnselectedWorryContent.value
  );
});

/**
 * 「次へ」ボタン押下時の処理
 *
 * - firstName, lastName の空白チェック
 * - 生年月日を `YYYY/MM/DD` 形式で整形
 * - Vuexに保存して確認画面へ遷移
 *
 * @function accept
 * @returns {void}
 */
const accept = () => {
  if (checkWhitespace(selectedInfo.value.firstName || "", firstNameErrorMessage, "first-name-error")) {
    return;
  }

  if (checkWhitespace(selectedInfo.value.lastName || "", lastNameErrorMessage, "last-name-error")) {
    return;
  }

  selectedInfo.value.birthday = `${birthday.value.year}/${birthday.value.month}/${birthday.value.date}`;
  selectedInfo.value.selectedWorryTags = selectedWorryTags.value;

  // 通常予約フラグを設定（子ども予約ではない）
  store.commit("booking/setIsChildBooking", false);

  // 悩みコンテンツの情報もVuexに保存
  store.commit("booking/setCustomerInfo", selectedInfo.value);
  store.commit("booking/setWorryContents", worryContents.value);

  RouterUtils.goTo(RouterConstants.CONTENT_CONFIRMATION_ROUTER_NAME);
};

/**
 * 既存ユーザーの悩み情報をセットする
 *
 * @param customerWorryTags - APIから取得した顧客の悩み情報
 */
const setExistingWorryTags = (customerWorryTags: Record<string, string[]>) => {
  if (!customerWorryTags || Object.keys(customerWorryTags).length === 0) {
    console.log("customerWorryTags is empty or null, returning early");
    return;
  }

  if (!worryContents.value || worryContents.value.length === 0) {
    console.log("worryContents is empty, cannot set worry tags");
    return;
  }

  // 顧客の悩み情報から、現在の悩みマスタに存在するものだけを選択
  const validWorryTagIds: number[] = [];

  // customerWorryTagsのキー（コンテンツID）と値（悩み名の配列）を正しく処理
  Object.entries(customerWorryTags).forEach(([contentId, worryNames]) => {
    if (Array.isArray(worryNames)) {
      // 該当するコンテンツを探す
      const targetContent = worryContents.value.find(content => content.id.toString() === contentId);

      if (targetContent) {
        // そのコンテンツ内のタグのみを対象とする
        worryNames.forEach((worryName: string) => {
          const matchingTag = targetContent.worry_tags.find(tag => tag.name === worryName);
          if (matchingTag) {
            validWorryTagIds.push(matchingTag.id);
          }
        });
      }
    }
  });

  // 重複を除去してセット
  selectedWorryTags.value = [...new Set(validWorryTagIds)];
};

/**
 * 名前入力欄の空白チェックユーティリティ
 *
 * @function checkWhitespace
 * @param {string} value - 入力値
 * @param {Ref<string>} errorMessage - エラーメッセージ格納用ref
 * @param {string} errorElementId - スクロール対象のエレメントID
 * @returns {boolean} trueならエラーあり
 */
const checkWhitespace = (value: string, errorMessage: Ref<string>, errorElementId: string) => {
  const stringHasWhitespaceRegex = /\s/;
  errorMessage.value = "";
  if (stringHasWhitespaceRegex.test(value)) {
    errorMessage.value = "名前にスペースは使用できません。";
    document.getElementById(errorElementId)?.scrollIntoView();
    return true;
  }
  return false;
};

/**
 * 郵便番号から住所を検索する
 *
 * @function searchAddress
 * @returns {Promise<void>}
 */
const searchAddress = async () => {
  if (!isValidZipcode.value) {
    return; // 郵便番号が無効な場合は何もしない
  }

  try {
    // 郵便番号を7桁の数字に正規化
    const normalizedZipcode = selectedInfo.value.zipcode?.replace(/-/g, "") || "";

    // 郵便番号検索APIを呼び出し
    const response = await axios.get(`https://zipcloud.ibsnet.co.jp/api/search`, {
      params: {
        zipcode: normalizedZipcode,
      },
    });

    if (response.data && response.data.results && response.data.results.length > 0) {
      const addressData = response.data.results[0];
      // 住所を組み立てて設定
      const fullAddress = `${addressData.address1}${addressData.address2}${addressData.address3}`;
      selectedInfo.value.address = fullAddress;
    }
  } catch (error) {
    console.log("住所検索に失敗しました:", error);
    // エラーが発生した場合は何もしない（既存の入力は保持）
  }
};

/**
 * 「戻る」ボタン押下時の処理（予約カレンダーに戻る）
 *
 * @function back
 * @returns {void}
 */
const back = () => {
  store.commit("booking/resetSelectedTime");
  RouterUtils.goTo(RouterConstants.BOOKING_CALENDAR_ROUTER_NAME);
};

/**
 * `selectedInfo.birthday` を元に `birthday` を年・月・日へパース
 *
 * @function setBirthday
 * @returns {void}
 */
const setBirthday = () => {
  const birthdayString = get(selectedInfo).birthday;

  if (birthdayString) {
    set(birthday.value, "year", moment(birthdayString).format("YYYY"));
    set(birthday.value, "month", moment(birthdayString).format("M"));
    set(birthday.value, "date", moment(birthdayString).format("D"));
  }
};

/**
 * コンポーネントマウント前に実行する初期化処理
 *
 * - 顧客情報（LINE連携 or API経由）を取得し、フォームに反映
 * - 生年月日フィールドの初期値をセット
 * - バリデーションや年リスト初期化も実行
 */
onBeforeMount(async () => {
  if (store.getters["booking/customerInfo"].email) {
    // Vuexに保持されている顧客情報を使用
    selectedInfo.value = get(store.getters["booking/customerInfo"]);
    selectedWorryTags.value = selectedInfo.value.selectedWorryTags || [];

    // 悩みコンテンツの情報も復元
    const savedWorryContents = store.getters["booking/worryContents"];
    if (savedWorryContents && savedWorryContents.length > 0) {
      worryContents.value = savedWorryContents;
    } else {
      await fetchWorryContents();
    }
  } else {
    // まず悩みコンテンツを取得
    await fetchWorryContents();

    // APIから顧客情報を取得し、初期値としてセット
    await axios
      .get(`${ApiRouterConstants.API_CUSTOMERS}/info`, {
        params: {
          clinic_id: store.getters["line_account/clinicId"],
          line_account_id: store.getters["line_account/id"],
        },
        headers: { Accept: "application/json" },
      })
      .then(res => {
        const nameArray = (res.data?.name || "").split(" ");
        const lastName = nameArray[0];
        const firstName = nameArray.slice(1).join(" ");

        set(selectedInfo.value, "firstName", firstName);
        set(selectedInfo.value, "lastName", lastName);
        set(selectedInfo.value, "tel", res.data?.phone || "");
        set(selectedInfo.value, "email", res.data?.email || "");
        set(selectedInfo.value, "address", res.data?.address || "");
        set(selectedInfo.value, "addressNumber", res.data?.address_number || "");
        set(selectedInfo.value, "birthday", res.data?.birthday || "");
        set(selectedInfo.value, "zipcode", res.data?.zipcode || "");
        set(selectedInfo.value, "gender", res.data?.gender || "male");

        // 既存ユーザーの悩み情報をセット（worryContents取得後に実行）
        if (res.data?.worry_tags) {
          setExistingWorryTags(res.data.worry_tags);
        }
      })
      .catch(() => {
        console.log("Not found");
      });
  }

  // 初期化処理
  set(selectedInfo.value, "note", "");
  set(selectedInfo.value, "noteSymptom", "");
  setBirthday();
  getYearsList();
  ValidateBookingSteps();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _directive_text_format = _resolveDirective("text-format")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/customer/bookings/child-booking",
        class: "child-link"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" お子様のご予約はこちら ")
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputText, {
          class: "input-text",
          modelValue: _unref(selectedInfo).lastName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectedInfo).lastName) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_9, _toDisplayString(firstNameErrorMessage.value), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_InputText, {
          class: "input-text",
          modelValue: _unref(selectedInfo).firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(selectedInfo).firstName) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_12, _toDisplayString(lastNameErrorMessage.value), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_13,
      _createVNode(_component_InputText, {
        class: "input-text",
        modelValue: _unref(selectedInfo).email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(selectedInfo).email) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _hoisted_14,
      _createVNode(_component_InputText, {
        inputmode: "numeric",
        class: "input-text",
        modelValue: _unref(selectedInfo).tel,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(selectedInfo).tel) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createVNode(_component_InputText, {
            class: "input-text",
            modelValue: _unref(selectedInfo).zipcode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(selectedInfo).zipcode) = $event))
          }, null, 8, ["modelValue"]), [
            [_directive_text_format, /\d|-/]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Button, {
            class: "address-search-btn",
            onClick: searchAddress,
            disabled: !_unref(isValidZipcode)
          }, {
            default: _withCtx(() => [
              _createTextVNode("住所検索")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_19,
      _createVNode(_component_InputText, {
        class: "input-text",
        modelValue: _unref(selectedInfo).address,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(selectedInfo).address) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _hoisted_20,
      _createVNode(_component_InputText, {
        class: "input-text",
        modelValue: _unref(selectedInfo).addressNumber,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(selectedInfo).addressNumber) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Dropdown, {
              modelValue: birthday.value.year,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((birthday.value.year) = $event)),
              options: yearsList.value,
              class: "w-full input-text mr-2"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_25
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Dropdown, {
              modelValue: birthday.value.month,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((birthday.value.month) = $event)),
              options: monthsList.value,
              class: "w-full input-text mr-2"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_28
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_Dropdown, {
              modelValue: birthday.value.date,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((birthday.value.date) = $event)),
              options: _unref(getDaysList),
              class: "w-full input-text mr-2"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_31
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_unref(RadioButton), {
            modelValue: _unref(selectedInfo).gender,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(selectedInfo).gender) = $event)),
            inputId: "male",
            name: "gender",
            value: "male"
          }, null, 8, ["modelValue"]),
          _hoisted_35
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_unref(RadioButton), {
            modelValue: _unref(selectedInfo).gender,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(selectedInfo).gender) = $event)),
            inputId: "female",
            name: "gender",
            value: "female"
          }, null, 8, ["modelValue"]),
          _hoisted_37
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_unref(RadioButton), {
            modelValue: _unref(selectedInfo).gender,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(selectedInfo).gender) = $event)),
            inputId: "unknown",
            name: "gender",
            value: "unknown"
          }, null, 8, ["modelValue"]),
          _hoisted_39
        ])
      ])
    ]),
    (worryContents.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(worryContents.value, (content) => {
            return (_openBlock(), _createElementBlock("div", {
              key: content.id,
              class: "worry-content-section"
            }, [
              _createElementVNode("h3", _hoisted_41, [
                _createTextVNode(_toDisplayString(content.name), 1),
                _hoisted_42
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.worry_tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.id,
                    class: "flex align-items-center"
                  }, [
                    _createVNode(_unref(Checkbox), {
                      modelValue: selectedWorryTags.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedWorryTags).value = $event)),
                      value: tag.id,
                      inputId: `worry-tag-${tag.id}`,
                      name: `worry-tag-${content.id}`
                    }, null, 8, ["modelValue", "value", "inputId", "name"]),
                    _createElementVNode("label", {
                      for: `worry-tag-${tag.id}`,
                      class: "ml-2"
                    }, _toDisplayString(tag.name), 9, _hoisted_44)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_45,
      _createVNode(_unref(Textarea), {
        class: "input-text others",
        rows: "5",
        modelValue: _unref(selectedInfo).noteSymptom,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(selectedInfo).noteSymptom) = $event)),
        placeholder: "例：〇時までにお店をでたい"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createVNode(_unref(Textarea), {
        class: "input-text others",
        rows: "5",
        modelValue: _unref(selectedInfo).note,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(selectedInfo).note) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createVNode(_component_Button, {
        class: "btn cancel-btn w-full",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("戻る")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn accept-btn w-full",
        onClick: accept,
        disabled: _unref(disableSubmitButton)
      }, {
        default: _withCtx(() => [
          _createTextVNode("次へ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})